import type { RunStatus } from './types'

export const STATUS_TONE: Record<RunStatus, 'brand' | 'success' | 'neutral'> = {
  upcoming: 'brand',
  running: 'success',
  finished: 'neutral',
}
export const STATUS_LABEL: Record<RunStatus, string> = {
  upcoming: 'Upcoming',
  running: 'In progress',
  finished: 'Finished',
}
